// import { push } from 'connected-react-router';
import fetch from 'isomorphic-fetch';
import { call } from 'redux-saga/effects'
import localforage from 'localforage';
import { includes } from 'ramda';
import {hasValue} from "@amsanalytics/react-shared-library";

/**
 * Add headers to api
 * @param options 
 * @param token 
 */
function addFileHeader(options: any = {}, contentType: string, token?: string) {
  const newOptions = { ...options };
  if (!options.headers) {
    newOptions.headers = {
      'Content-Type': contentType,
      ...options.headers,
    };
  }
  // Add bearer token if it exists
  if (token) {
    newOptions.headers.Authorization = `Bearer ${token}`;
  }

  return newOptions;
}


export function* httpPost(
  url: string,
  body: any,
) {
  try {
    const config: { api_endpoint: string } = yield call(fetchConfig);
    url = `${config.api_endpoint}/${url}`;
    const options = { method: 'POST', body: JSON.stringify(body) };
    const response: { json: string } = yield call(fetch, url, addHeader(options));
    return response;
  } catch (e) {
    const errorEffect = getErrorEffect(e); // replaces handleError
    if (errorEffect) {
      yield errorEffect;
    }
  }
}


export function* httpPut(
  url: string,
  body: any
) {
  try {
    const getClientId = async () => localforage.getItem('clientId');
    const clientId: string | undefined = yield (call(getClientId));
    const config: { api_endpoint: string } = yield call(fetchConfig);
    url = `${config.api_endpoint}/${url}`;
    if (hasValue(clientId)) {
      if (includes("?", url)) {
        url = `${url}&clientId=${clientId}`;
      } else {
        url = `${url}?clientId=${clientId}`;
      }
    }
    const options = { method: 'PUT', body: JSON.stringify(body) };
    const response: { json: string } = yield call(fetch, url, addHeader(options));
    return response;
  } catch (e) {
    const errorEffect = getErrorEffect(e); // replaces handleError
    if (errorEffect) {
      yield errorEffect;
    }
  }
}

export function* httpPostFile(
  url: string,
  body: any,
  contentType: string,
) {
  try {
    const getClientId = async () => localforage.getItem('clientId');
    const clientId: string = yield (call(getClientId));
    const config: { api_endpoint: string } = yield call(fetchConfig);
    url = `${config.api_endpoint}/${url}`;
    if (hasValue(clientId)) {
      if (includes("?", url)) {
        url = `${url}&clientId=${clientId}`;
      } else {
        url = `${url}?clientId=${clientId}`;
      }
    }
    const options = { method: 'POST', mode: 'cors', body };
    const response: {} = yield call(fetch, url, addFileHeader(options, contentType));
    return response;
  } catch (e) {
    const errorEffect = getErrorEffect(e);
    if (errorEffect) {
      yield errorEffect;
    }
  }
}

export function* httpGet(url: string) {
  try {
    const options: any = { method: 'GET' };
    options.headers = {
      ...options.headers,
    };
    const config: { api_endpoint: string } = yield call(fetchConfig);
    url = `${config.api_endpoint}/${url}`;

    const response: { json: string } = yield call(fetch, url, options);
    return response;
  } catch (e) {
    const errorEffect = getErrorEffect(e); // replaces handleError
    if (errorEffect) {
      yield errorEffect;
    }
  }
}

export const httpGetAsync = async (url: string) => {
  try {
    const getClientId = async () => localforage.getItem('clientId');
    const clientId: string | undefined = await getClientId() as (string | undefined);
    const config: { api_endpoint: string } = await fetchConfig();
    url = `${config.api_endpoint}/${url}`;
    if (hasValue(clientId)) {
      if (includes("?", url)) {
        url = `${url}&clientId=${clientId}`;
      } else {
        url = `${url}?clientId=${clientId}`;
      }
    }

    const response = await fetch(url, addHeader({ method: 'GET' }));
    return response;
  } catch (e) {
    const errorEffect = getErrorEffect(e); // replaces handleError
    if (errorEffect) {
      // yield errorEffect;
      alert('error occurred');
    }
  }
}

export function* httpDelete(
  url: string,
) {
  try {
    const getClientId = async () => localforage.getItem('clientId');
    const clientId: string = yield (call(getClientId));
    const config: { api_endpoint: string } = yield call(fetchConfig);
    url = `${config.api_endpoint}/${url}`;
    if (hasValue(clientId)) {
      if (includes("?", url)) {
        url = `${url}&clientId=${clientId}`;
      } else {
        url = `${url}?clientId=${clientId}`;
      }
    }
    const response: {} = yield call(fetch, url, addHeader({ method: 'DELETE' }));
    return response;
  } catch (e) {
    const errorEffect = getErrorEffect(e); // replaces handleError
    if (errorEffect) {
      yield errorEffect;
    }
  }
}

function getErrorEffect(error: any) {
  if (error.code === 401) {
    //return put(push('/error')); // returns the effect for the `request` generator to yeild
    return  '';
  }

  if (error.code == 400) {
    // return displayToast(error); // assuming `displayToast` is an effect that can be yielded directly
    // console.log('todo');
  }
}


/**
 * Add headers to api
 * @param options 
 * @param token 
 */
function addHeader(options: any = {}, token?: string) {
  const newOptions = { ...options };
  if (!options.headers) {
    newOptions.headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      ...options.headers,
    };
  }
  // Add bearer token if it exists
  if (token) {
    newOptions.headers.Authorization = `Bearer ${token}`;
  }

  return newOptions;
}

// Async Methods
export const httpPostAsync = async (
  url: string,
  body: any
) => {
  try {
    const getClientId = async () => localforage.getItem('clientId');
    const clientId: string | undefined = await getClientId() as (string | undefined);
    const config: { api_endpoint: string } = await fetchConfig();
    url = `${config.api_endpoint}/${url}`;
    if (hasValue(clientId)) {
      if (includes("?", url)) {
        url = `${url}&clientId=${clientId}`;
      } else {
        url = `${url}?clientId=${clientId}`;
      }
    }
    const options = { method: 'POST', body: JSON.stringify(body) };
    const response = await fetch(url, addHeader(options));
    return response;
  } catch (e) {
    const errorEffect = getErrorEffect(e); // replaces handleError
    if (errorEffect) {
      // yield errorEffect;
      alert('error occurred');
    }
  }
}

export const fetchConfig = async () => {
  try {
    const cacheBuster = new Date().getTime(); // Generate a unique timestamp
    const response = await fetch(`/api-info.apisettings?cacheBuster=${cacheBuster}`);
    if (!response.ok) {
      throw new Error(`Network response was not ok (${response.status} ${response.statusText})`);
    }
    return response.json();
  } catch (error) {
    console.error('Error fetching configuration:', error);
    return null;
  }
};

// Async version of the httpFormData function.
export const httpFormDataAsync = async (
  url: string,
  method: string,
  body: any,
  token: string
) => {
  try {
    const config: any = await fetchConfig();
    url = `${config.api_endpoint}/${url}`;

    const options = { method: method, body: body, headers: { Authorization: `Bearer ${token}` } };
    const response = await fetch(url, options);
    return response;
  } catch (e) {
    const errorEffect = getErrorEffect(e);
    if (errorEffect) {
      alert('error occurred');
    }
  }
}